module.exports = __webpack_public_path__ + "media/club_product_v2/background-77f8f9c8.png";